import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const nbTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Navn (små bokstaver, ingen spesialtegn)',
    add: 'Legg til',
    allowedFileTypes: 'Tillatte filtyper',
    allowedFileTypesDescription:
      'Begrens tillatte filtyper (f.eks. image/*, program/pdf). La stå tomt for å tillate alle typer.',
    allowMultipleFiles: 'Tillat flere filer',
    amountInCents: 'Beløp i cent',
    basePrice: 'Grunnpris',
    bcc: 'BCC',
    brand: 'Merke',
    cc: 'CC',
    checkboxPlural: 'Avmerkingsboksfelt',
    checkboxSingular: 'Avmerkingsboks',
    checkedByDefault: 'Avmerket som standard',
    chooseConfirmationType:
      'Velg om du vil vise en melding på siden eller omdirigere til en annen side etter at de har sendt inn skjemaet.',
    condition: 'Tilstand',
    confirmationMessage: 'Bekreftelsesmelding',
    confirmationType: 'Bekreftelsestype',
    countryPlural: 'Country Fields',
    countrySingular: 'Land',
    creditCard: 'Kredittkort',
    customURL: 'Egendefinert URL',
    datePlural: 'Datofelt',
    dateSingular: 'Dato',
    defaultValue: 'Standardverdi',
    divide: 'Del opp',
    documentToLinkTo: 'Dokument å lenke til',
    doesNotEqual: 'Er ikke lik',
    emailFrom: 'E-post fra',
    emailPlural: 'E-postfelt',
    emailsDescription:
      'Send tilpassede e-poster når skjemaet sendes inn. Bruk kommadelte lister for å sende samme e-post til flere mottakere. For å referere til en verdi fra dette skjemaet, pakk feltets navn med doble krøllede parenteser, dvs. {{firstName}}. Du kan bruke et jokertegn {{*}} for å skrive ut alle data og {{*:table}} for å formatere det som en HTML-tabell i e-posten.',
    emailSingular: 'E-post',
    emailTo: 'E-post til',
    equals: 'Er lik',
    field: 'Felt',
    fields: 'Felter',
    fieldWidth: 'Feltbredde (prosent)',
    hasAnyValue: 'Har noen verdi',
    internalLink: 'Intern lenke',
    label: 'Etikett',
    maxFileSize: 'Maks filstørrelse (byte)',
    maxFileSizeDescription: 'Maksimal filstørrelse i byte. La stå tomt uten grenser.',
    message: 'Melding',
    messageDescription: 'Skriv inn meldingen som skal sendes i denne e-posten.',
    messagePlural: 'Meldingsblokker',
    messageSingular: 'Melding',
    mimeType: 'MIME-type',
    mimeTypePlural: 'MIME-typer',
    mimeTypeSingular: 'MIME-type',
    multiply: 'Multipliser',
    numberPlural: 'Nummerfelt',
    numberSingular: 'Nummer',
    optionPlural: 'Alternativer',
    optionSingular: 'Alternativ',
    paymentFieldPlural: 'Betalingsfelt',
    paymentFieldSingular: 'Betaling',
    paymentProcessor: 'Betalingsbehandler',
    paymentStatus: 'Status',
    placeholder: 'Plassholder',
    priceConditions: 'Prisbetingelser',
    priceConditionsPlural: 'Prisbetingelser',
    priceConditionsSingular: 'Pris Tilstand',
    radioOptions: 'Alternativer for radioattributt',
    radioPlural: 'Radiofelt',
    radioSingular: 'Radio',
    redirect: 'Omdirigere',
    replyTo: 'Svar til',
    required: 'Obligatorisk',
    selectOptions: 'Velg Alternativer',
    selectPlural: 'Velg Felter',
    selectSingular: 'Velg',
    statePlural: 'Statens felt',
    stateSingular: 'stat',
    staticValue: 'Statisk verdi',
    subject: 'Emne',
    submitButton: 'Send inn knappetikett',
    subtract: 'Trekk fra',
    textareaPlural: 'Tekstområdefelt',
    textareaSingular: 'Tekstområde',
    textPlural: 'Tekstfelt',
    textSingular: 'Tekst',
    title: 'Tittel',
    token: 'token',
    uploadCollection: 'Last opp samling',
    uploadCollectionDescription: 'Velg hvilken opplastingssamling du vil lagre filer i',
    uploadFieldPlural: 'Last opp felt',
    uploadFieldSingular: 'Last opp',
    urlToRedirectTo: 'URL å omdirigere til',
    value: 'Verdi',
    valueOfField: 'Verdi av felt',
    valueType: 'Verditype',
  },
}

export const nb: PluginLanguage = {
  dateFNSKey: 'nb',
  translations: nbTranslations,
}
